export default __webpack_public_path__ + "static/topic14-eafbfd29a0315b21e481d7f247fd1836.png";